module.exports = __webpack_public_path__ + "img/studio_.fae55706.png";